// ============================================================
// utils.js — utilidades genéricas
// ============================================================

/**
 * Atajo querySelector
 * @param {string} sel
 * @param {Document|HTMLElement} ctx
 * @returns {HTMLElement|null}
 */
export const qs = (sel, ctx = document) => ctx.querySelector(sel);

/**
 * Atajo querySelectorAll → Array
 */
export const qsa = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

/**
 * Delegación de eventos
 */
export function on(root, eventName, selector, handler) {
  root.addEventListener(eventName, (e) => {
    const target = e.target.closest(selector);
    if (target && root.contains(target)) {
      handler(e, target);
    }
  });
}

/**
 * Debounce simple
 */
export function debounce(fn, wait = 200) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), wait);
  };
}

/**
 * Crea un elemento desde una cadena HTML
 */
export function el(html) {
  const tpl = document.createElement('template');
  tpl.innerHTML = html.trim();
  return tpl.content.firstElementChild;
}

/**
 * Escape HTML básico (anti-XSS)
 */
export function esc(str = '') {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
